module.exports = __webpack_public_path__ + "static/media/5A.a215f2e8.jpg";